module.exports = __webpack_public_path__ + "img/tenor.a742721e.gif";